import { Button, Typography } from '@mui/material';
import { captureException } from '@sentry/react';
import { colors, EmailIcon } from '@truvhq/ui';
import { useSnackbar } from 'notistack';

import { useAuth } from 'shared/lib/auth/useAuth';
import { AuthLayoutTemplate } from 'shared/ui/AuthLayoutTemplate';
import { AuthStatusMessage } from 'shared/ui/AuthStatusMessage';

import { resendVerificationEmail } from './api';

export const UnverifiedEmail = () => {
  const { user } = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  function handleResendClick() {
    if (user !== null) {
      resendVerificationEmail(user.id)
        .then(() => {
          enqueueSnackbar('Email sent');
        })
        .catch((error) => {
          captureException(error);
        });
    }
  }

  return (
    <AuthLayoutTemplate pageName="UnverifiedEmail">
      <AuthStatusMessage
        title="Verify your email"
        subtitle={
          <Typography color={colors.grey60} variant="body1">
            An email has been sent to <strong>{user?.email}</strong>, click the button inside. If you don't see the
            email in your inbox, check the spam folder or resend the email.
          </Typography>
        }
        button={
          <Button
            variant="outlined"
            color="primary"
            onClick={handleResendClick}
            sx={{ width: { xs: '100%', sm: 'auto' } }}
          >
            Resend email
          </Button>
        }
        icon={<EmailIcon className="h-[40px] w-[40px] ml-[-4px] text-primary-main" />}
      />
    </AuthLayoutTemplate>
  );
};
